import { connectedStore } from '../../store';
import selectors from '../selectors';

const getTheme = (themeId) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getTheme(state, themeId);
};

export default getTheme;
